import { Flex, Skeleton } from '@kognitos/lattice';

const UserDetailsSkeleton = () => {
  return (
    <Flex gap={2} className="p-2" data-testid="user-details-skeleton">
      <Skeleton className="h-7 w-7 rounded-lg" />
      <Flex direction="column" gap={1} width="full">
        <Skeleton className="h-3 w-1/3" />
        <Skeleton className="h-3 w-1/2" />
      </Flex>
    </Flex>
  );
};

export default UserDetailsSkeleton;
